import React, { useState, useEffect, useRef } from "react"
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { debounce } from 'lodash';
import {
  Box,
  Button,
  TextField,
} from '@material-ui/core';

import "./Home.css"

import Step0 from "../components/commandes/Step0"
import Step1 from "../components/commandes/Step1"
import Step2 from "../components/commandes/Step2"
import Step3 from "../components/commandes/Step3"
import Step4 from "../components/commandes/Step4"
import Step5 from "../components/commandes/Step5"
import Step6 from "../components/commandes/Step6"
import Step7 from "../components/commandes/Step7"
import Step8 from "../components/commandes/Step8"

import EnergieRep1Icon from "../images/energie-rep1.js"
import EnergieRep2Icon from "../images/energie-rep2.js"
import EnergieRep3Icon from "../images/energie-rep3.js"
import EnergieRep4Icon from "../images/energie-rep4.js"

import EndroitRep1Icon from "../images/endroit-rep1.js"
import EndroitRep2Icon from "../images/endroit-rep2.js"
import EndroitRep3Icon from "../images/endroit-rep3.js"
import EndroitRep4Icon from "../images/endroit-rep4.js"

import RechercheRep1Icon from "../images/recherche-rep1.js"
import RechercheRep2Icon from "../images/recherche-rep2.js"
import RechercheRep3Icon from "../images/recherche-rep3.js"
import RechercheRep4Icon from "../images/recherche-rep4.js"

import BaseRep1Icon from "../images/base-rep1.js"
import BaseRep2Icon from "../images/base-rep2.js"
import BaseRep3Icon from "../images/base-rep3.js"
import BaseRep4Icon from "../images/base-rep4.js"
import BaseRep5Icon from "../images/base-rep5.js"

import CremeRep1Icon from "../images/creme-rep1.js"
import CremeRep2Icon from "../images/creme-rep2.js"

import OptionRep1Icon from "../images/option-rep1.js"
import OptionRep2Icon from "../images/option-rep2.js"
import OptionRep3Icon from "../images/option-rep3.js"

import ImageSmoothie0 from "../images/matcha_0.png"
import ImageSmoothie1 from "../images/ube_1.png"
import ImageSmoothie2 from "../images/acai_2.png"
import ImageSmoothie3 from "../images/spiruline_3.png"

import SelectedBlueIcon from "../images/selected-blue.svg"
import CheckedStepperIcon from "../images/checked-stepper.svg"
import GeminiWhiteIcon from "../images/gemini-white.svg"
import HomeWhiteIcon from "../images/home-white.svg"
import SmoothieImage from "../images/smoothieImage.svg"
import SearchImage from "../images/searchImage.svg"

export const allQuestions = {
  "step1" : {
    //title : "Ta vibes",
    subTitle : <>Ton mood du moment est plutôt ...</>,
    questions : [
      {title : `Audacieux`, forEnd : "Audacieux", icon : <EnergieRep1Icon/>, pointFor : 2},
      {title : `Efficace`, forEnd : "Efficage", icon : <EnergieRep2Icon/>, pointFor : 3},
      {title : `Inspiré`, forEnd : "Inspiré", icon : <EnergieRep3Icon/>, pointFor : 0},
      {title : `Sociable`, forEnd : "Sociable", icon : <EnergieRep4Icon/>, pointFor : 1},
    ]
  },
  "step2" : {
    //title : "Ta vibes",
    subTitle : <>Ton spot idéal pour faire émerger des idées ?</>,
    questions : [
      {title : <>Un coffee shop<br/>calme</>, forEnd : "Un coffee shop calme", icon : <EndroitRep1Icon/>, pointFor : 0},
      {title : <>Un atelier<br/>créatif</>, forEnd : "Un atelier créatif", icon : <EndroitRep2Icon/>, pointFor : 2},
      {title : <>Une terrasse<br/>animée</>, forEnd : "Une terrasse animée", icon : <EndroitRep3Icon/>, pointFor : 1},
      {title : <>Un open space<br/>dynamique</>, forEnd : "Un open space dynamique", icon : <EndroitRep4Icon/>, pointFor : 3},
    ]
  },
  "step3" : {
    //title : "Ta vibes",
    subTitle : <>Ce que tu attends de ce smoothie ?</>,
    questions : [
      {title : `Une note de légéreté`, forEnd : "Une note de légéreté", icon : <RechercheRep1Icon/>, pointFor : 0},
      {title : `Un twist inattendu`, forEnd : "Un twist inattendu", icon : <RechercheRep2Icon/>, pointFor : 2},
      {title : `Une pause gourmande`, forEnd : "Une pause gourmande", icon : <RechercheRep3Icon/>, pointFor : 1},
      {title : `Un boost d’énergie`, forEnd : "Un boost d'énergie", icon : <RechercheRep4Icon/>, pointFor : 3},
    ]
  },
  "step4" : {
    //title : "Un peu de personnalisation",
    subTitle : "Quels sont tes besoins du jour ?",
    questions : [
      {title : `Hydratation & Focus`, forEnd : "Hydratation & Focus", icon : <OptionRep1Icon/>, baristaTitle : "Acide Hyaluronique"},
      {title : `Éclat & Anti-stress`, forEnd : "Éclat & Anti-stress", icon : <OptionRep2Icon/>, baristaTitle : "Collagène"},
      {title : `Je suis bien comme je suis`, forEnd : "Je suis bien comme je suis", icon : <OptionRep3Icon/>, baristaTitle : "Non"},
    ]
  },
  "step5" : {
    //title : "Un peu de personnalisation",
    subTitle : "Quel est ton lait préféré ?",
    questions : [
      {title : `Lait de vache`, forEnd : "Lait de vache", icon : <BaseRep1Icon/>, view:true},
      {title : `Lait d’avoine`, forEnd : "Lait d'avoine", icon : <BaseRep2Icon/>, view:true},
      {title : `Lait de coco`, forEnd : "Lait de coco", icon : <BaseRep3Icon/>, view:false},
      {title : `Lait d’amande`, forEnd : "Lait d'amande", icon : <BaseRep4Icon/>, view:true},
      {title : `Lait de soja`, forEnd : "Lait de soja", icon : <BaseRep5Icon/>, view:true},
    ]
  },
  "step6" : {
    //title : "Un peu de personnalisation",
    subTitle : "Et pour la crème ?",
    questions : [
      {title : `Crème de mascarpone classique`, forEnd : "Crème de mascarpone classique", subTitle:"(Lait de vache)", icon : <CremeRep1Icon/>, baristaTitle : "Mascarpone classique"},
      {title : `Crème de mascarpone végétale`, forEnd : "Crème de mascarpone végétale", subTitle:"(Lait de soja vegan)", icon : <CremeRep2Icon/>, baristaTitle : "Mascarpone végétale"},
    ]
  },
}

export const smoothieTypes = [
  {
    id : 0,
    name : "Le Matcha Visionnaire",
    desc1 : "Le smoothie de ceux qui repèrent les tendances avant tout le monde",
    desc2 : "L’alliance parfaite entre la douceur gourmande de la fraise Charlotte et la clarté d'esprit du matcha. Un équilibre idéal pour structurer vos prochaines idées de génie.",
    image : ImageSmoothie0,
  },
  {
    id : 1,
    name : "Le Ube Collaboratif",
    desc1 : "L'intelligence collective en boisson",
    desc2 : "L'alliance audacieuse de la mangue et de la douceur violette du Ube. Une recette surprenante, parfaite pour nourrir votre créativité et inspirer vos synergies aujourd’hui.",
    image : ImageSmoothie1,
  },
  {
    id : 2,
    name : "L'Açaï Disruptif",
    desc1 : "Pour casser les codes et sortir du cadre avec fraîcheur",
    desc2 : "Le peps de l’ananas rencontre la puissance antioxydante de l’açaï pour un shot de fraîcheur spontanée. Parce que l’innovation naît aussi en s'amusant !",
    image : ImageSmoothie2,
  },
  {
    id : 3,
    name : "La Spiruline Performance",
    desc1 : "Le choix de l'efficacité pure et des objectifs dépassés",
    desc2 : "Le dynamisme de la framboise associé à l’intensité de la spiruline bleue. Un boost d’énergie pure pour garder une longueur d’avance et piloter vos projets d’une main de maître.",
    image : ImageSmoothie3,
  }
]

const defaultReps = {
  name : "",
  q1 : null, //step1
  q2 : null, //step2
  q3 : null, //step3
  q4 : null, //step4
  q5 : null, //step5
  q6 : null, //step6,
  smoothieChoiceID : null,
}

const Home = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(0)
  const [reps, setReps] = useState(defaultReps)

  useEffect(() => {
    if (step === 0) { //reset quand on revient à la step 0
      setReps(defaultReps)
    }
  }, [step])

  useEffect(() => {
    console.log(reps)
  }, [reps])

  //on revient à l'accueil si on a pas de clique sur la page pendant 30 secondes (30000ms)
  useEffect(() => {
    let timeoutClick = null
    function recordClick() {
      clearTimeout(timeoutClick)
      //console.log("click on page")
      timeoutClick = setTimeout(() => {
        console.log("timeout pour inactivité")
        setStep(0)
        setReps(defaultReps)
      }, 30000);
    }
    if ((step !== 0) || (step === 0 && reps?.name?.trim()?.length > 0)) {
      document.body.addEventListener("click", recordClick)
      recordClick()
    }
    return () => {
      document.body.removeEventListener("click", recordClick);
      clearTimeout(timeoutClick);
    }
  }, [step, reps])

  return (
    <>
      <Helmet>
        <title>Commande | Gemini Bar</title>
      </Helmet>

      <img src={ImageSmoothie0} style={{width:"0", height:"0"}}/>
      <img src={ImageSmoothie1} style={{width:"0", height:"0"}}/>
      <img src={ImageSmoothie2} style={{width:"0", height:"0"}}/>
      <img src={ImageSmoothie3} style={{width:"0", height:"0"}}/>
      <img src={SelectedBlueIcon} style={{width:"0", height:"0"}}/>
      <img src={CheckedStepperIcon} style={{width:"0", height:"0"}}/>
      <img src={GeminiWhiteIcon} style={{width:"0", height:"0"}}/>
      <img src={HomeWhiteIcon} style={{width:"0", height:"0"}}/>
      <img src={SmoothieImage} style={{width:"0", height:"0"}}/>
      <img src={SearchImage} style={{width:"0", height:"0"}}/>

      <img src="./static/logo_noir.png" style={{width:"0", height:"0"}}/>
      <img src="./static/logo_blanc.png" style={{width:"0", height:"0"}}/>

      {step === 0 &&
        <Step0
          step={step}
          setStep={setStep}
          reps={reps}
          setReps={setReps}
        />
      }

      {step === 1 &&
        <Step1
          step={step}
          setStep={setStep}
          reps={reps}
          setReps={setReps}
        />
      }

      {step === 2 &&
        <Step2
          step={step}
          setStep={setStep}
          reps={reps}
          setReps={setReps}
        />
      }

      {step === 3 &&
        <Step3
          step={step}
          setStep={setStep}
          reps={reps}
          setReps={setReps}
        />
      }

      {step === 4 &&
        <Step4
          step={step}
          setStep={setStep}
          reps={reps}
          setReps={setReps}
        />
      }

      {step === 5 &&
        <Step5
          step={step}
          setStep={setStep}
          reps={reps}
          setReps={setReps}
        />
      }

      {step === 6 &&
        <Step6
          step={step}
          setStep={setStep}
          reps={reps}
          setReps={setReps}
        />
      }

      {step === 7 &&
        <Step7
          step={step}
          setStep={setStep}
          reps={reps}
          setReps={setReps}
        />
      }

      {step === 8 &&
        <Step8
          step={step}
          setStep={setStep}
          reps={reps}
          setReps={setReps}
        />
      }
    </>
  );
};

export default Home;
